import { showError, showWarning } from "helpers/utils/customAlert";
import moment from "moment";

export const apiDateToMoment = dateStr => (dateStr ? moment.utc(dateStr) : null);

export const apiTimeToMoment = timeStr => (timeStr ? moment.utc(timeStr) : null);

export const formatDate = dateStr => (dateStr ? moment.utc(dateStr).format("DD/MM/YYYY") : "");

export const formatTime = timeStr => (timeStr ? moment.utc(timeStr).format("hh:mm A") : "");

export const getDisplayTime = isoString => {
  if (!isoString) return null;

  const utcMoment = moment.utc(isoString);

  if (!utcMoment.isValid()) return null;

  const localDate = new Date();

  localDate.setHours(utcMoment.hours());
  localDate.setMinutes(utcMoment.minutes());
  localDate.setSeconds(0);
  localDate.setMilliseconds(0);

  return localDate;
};

export const combineDateAndTime = (dateInput, timeInput) => {
  if (!dateInput || !timeInput) return null;

  const dateMoment = moment(dateInput);

  const timeMoment = moment(timeInput, ["HH:mm:ss", "HH:mm", "hh:mm A", moment.ISO_8601]);

  if (!dateMoment.isValid() || !timeMoment.isValid()) return null;

  dateMoment.set({
    hour: timeMoment.get("hour"),
    minute: timeMoment.get("minute"),
    second: timeMoment.get("second") || 0,
    millisecond: 0,
  });

  return dateMoment.format();
};
export const getAvatarStyle = name => {
  if (!name) {
    return {
      background: "#f1f5f9",
      color: "#64748b",
    };
  }

  const charCode = name.toUpperCase().charCodeAt(0);

  if (charCode >= 65 && charCode <= 90) {
    const hue = ((charCode - 65) * 137.5) % 360;

    return {
      background: `linear-gradient(
        135deg,
        hsl(${hue},85%,72%),
        hsl(${(hue + 25) % 360},80%,60%)
      )`,
      color: "#ffffff",
      border: "none",
    };
  }

  return {
    background: "#f1f5f9",
    color: "#64748b",
  };
};
export const getInitials = (name, fallback = "A") => {
  if (!name || typeof name !== "string" || name.trim() === "Admin") {
    return fallback;
  }

  const parts = name.trim().split(/\s+/); // Multiple spaces को भी handle करता है

  if (parts.length >= 2) {
    const firstInitial = parts[0].charAt(0);
    const lastInitial = parts[parts.length - 1].charAt(0);
    return `${firstInitial}${lastInitial}`.toUpperCase();
  }

  return parts[0].charAt(0).toUpperCase();
};
export const openInNewTab = url => {
  window.open(url, "_blank", "noopener,noreferrer");
};
export const formatINR = value => {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    value === "0" ||
    Number.isNaN(Number(value))
  ) {
    return "-";
  }

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(value));
};


export const handleApiError = (error, onJustificationRequired) => {
  if (error?.hasResponse === true && typeof onJustificationRequired === "function") {
    showWarning(error, onJustificationRequired);
  } else {
    showError(error);
  }
};
